const regex = / /g;

export class CollectionFilters {
  options: CollectionFilterOptions;
  baseURI: string;
  divToAppendTo: HTMLElement;
  collectionType: string;
  activeTags: Array<string>;
  requestPath: string;
  collectionHandle: string;
  currentTags: Array<CollectionTag>;
  supportedTags: Array<FilterTag>;
  filterTags: Array<CollectionTag>;
  filtered: Array<CollectionTag>;

  constructor(options: CollectionFilterOptions) {
    this.baseURI = 'https://api.binderpos.com/shopify/filterTags/';
    this.divToAppendTo = document.querySelector(options.divToAppendTo);
    this.collectionType = options.collectionType;
    this.requestPath = options.requestPath;
    this.collectionHandle = options.collectionHandle;
    this.activeTags =
      options.activeTags.length > 0 ? JSON.parse(options.activeTags) : '';
    this.currentTags =
      options.collectionTags.length > 0
        ? JSON.parse(options.collectionTags)
        : '';
    this.supportedTags = undefined;
    this.filterTags = undefined;
  }

  init() {
    if (localStorage.getItem(this.collectionType)) {
      this.supportedTags = JSON.parse(
        localStorage.getItem(this.collectionType)
      );
      if (this.supportedTags.length == 0) {
        this.divToAppendTo.innerHTML =
          `<p style="white-space: break-spaces; text-align: center;">Filters for ` +
          this.collectionType +
          ` not currently supported.</p>`;
      }
      this.processBinderTags();
      this.loadBinderTags().then((res) => {
        this.supportedTags = res;
        this.setLocalStorage();
      });
    } else {
      this.divToAppendTo.innerHTML = `<p style="white-space: break-spaces; text-align: center;">Fetching Filters for the First Time</p>`;
      this.loadBinderTags().then((res) => {
        if (res.length == 0) {
          this.divToAppendTo.innerHTML =
            `<p style="white-space: break-spaces; text-align: center;">Filters for ` +
            this.collectionType +
            ` not currently supported.</p>`;
        } else {
          this.divToAppendTo.innerHTML = ``;
        }
        this.supportedTags = res;
        this.setLocalStorage();
        this.processBinderTags();
      });
    }
  }

  /**
   * Imeplementation of Shopify's handleize
   * 
   * https://shopify.dev/api/liquid/filters/string-filters
   * https://gist.github.com/tyteen4a03/3420a9e121d13b091343
   * 
   * The string is converted to lowercase, and any spaces and special characters replaced by hyphens (-). 
   * If a title contains multiple consecutive spaces or special characters, then they're replaced by a single hyphen. 
   * Spaces and special characters are trimmed off of the beginning and end of the handle.
   * 
   */
  handleize(str: string) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
    
    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    // Replaces non-standard characters aside from é for things like pokémon go
    str = str.replace(/[^a-z^A-Z^0-9^é]+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }

    str = str.replace('ø','o').replace('æ','ae').replace('å','a');

    return str
  }

  setLocalStorage() {
    localStorage.setItem(
      this.collectionType,
      JSON.stringify(this.supportedTags)
    );
  }

  processBinderTags() {
    this.supportedTags.forEach((bt) => {
      this.filterTags = this.generateDisplayTags(bt.tags);
      let ul = this.generateFilterListCategory(bt);
      this.filterTags.forEach((ft) => {
        this.generateFilterListItem(ft, ul, bt);
      });
    });
    this.initInputHandlers();
  }

  initInputHandlers() {
    let inputs = document.querySelectorAll('[filterCheckbox]');
    inputs.forEach((input) => {
      input.addEventListener('keyup', this.filter);
    });
  }

  filter(e: any) {
    let query = e.target.value.replace(regex, '_').toUpperCase();
    var filters = document.querySelectorAll('ul.' + e.target.id + ' li');
    for (let i = 0; i < filters.length; i++) {
      if (
        filters[i].getAttribute('filter-name').toUpperCase().includes(query)
      ) {
        filters[i].classList.remove('hide');
      } else {
        filters[i].classList.add('hide');
      }
    }
  }

  generateFilterListItem(
    ft: CollectionTag,
    ul: HTMLUListElement,
    bt: FilterTag
  ) {
    var li = document.createElement('li');
    li.setAttribute('filter-name', ft.tag.replace(regex, '_').toUpperCase());
    var span = document.createElement('span');
    span.className = 'custom-checkbox';
    var a = document.createElement('a');
    if (ft.active) {
      a.setAttribute('data-tagname', ft.handle);
      a.className = 'selected';
      a.setAttribute('title', 'Remove ' + ft.tag + ' from your selection');
      a.href = '#';
    } else {
      if (this.activeTags.length == 0) {
        a.href =
          '/collections/' +
          (this.collectionHandle ? this.collectionHandle : 'all') +
          '/' +
          ft.handle;
      } else {
        a.href = this.requestPath + '+' + ft.handle;
      }
      a.setAttribute('title', 'Filter by ' + bt.name + ': ' + ft.tag);
    }
    var label = document.createElement('span');
    label.className = 'filter-box';
    ul.appendChild(li);
    li.appendChild(span);
    span.appendChild(a);
    a.appendChild(label);
    a.innerHTML += ' ' + ft.tag;
  }

  generateFilterListCategory(bt: FilterTag) {
    var strong = document.createElement('strong');
    strong.innerHTML = bt.name;
    this.divToAppendTo.appendChild(strong);
    if (this.filterTags.length > 6) {
      var input = document.createElement('input');
      input.setAttribute('filterCheckbox', null);
      input.className = 'checkbox__search';
      input.setAttribute('placeholder', 'Search ' + bt.name + "s");
      input.id = bt.name.replace(regex, '_').toUpperCase();
      this.divToAppendTo.appendChild(input);
    }
    var ul = document.createElement('ul');
    ul.className = bt.name.replace(regex, '_').toUpperCase();
    this.divToAppendTo.appendChild(ul);
    return ul;
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  stringIncludes(array: Array<string>, word: string) {
    return array.includes(word);
  }

  generateDisplayTags(supportedTags: Array<string>) {
    if (this.currentTags.length >= 1000 || this.currentTags.length === 0) {
      // If the collection tag limit has been reached, Shopify wont have tags the users need so we show all of them instead
      this.filtered = supportedTags.map((tag: string) => {
        return {
          tag,
          handle: this.handleize(tag),
          active: false,
        }
      })
    } else {
      let transformedSupportedTags = supportedTags.map((tag: string) => tag.replace(/"/g, "'").toUpperCase());
      this.filtered = this.currentTags.filter((t: CollectionTag) =>
        this.stringIncludes(transformedSupportedTags, t.tag.toUpperCase())
      );
    }

    return this.filtered.map((t: CollectionTag) => {
      if (this.stringIncludes(this.activeTags, t.tag)) {
        t.active = true;
        return t;
      }
      t.active = false;
      return t;
    });
  }

  // Needs to match the contains check in sidebar.standard.liquid in the 'filter' case match
  createShortCode(type: string) {
    switch (type.toLowerCase()) {
      case 'mtg single':
        return 'mtg';
      case 'pokemon single':
        return 'pkm';
      case 'yu gi oh single':
      case 'yugioh single':
        return 'ygo';
      case 'dragon ball super single':
        return 'dbs';
      case 'flesh and blood single':
        return 'fab';
      default:
        return null;
    }
  }

  fetchApi<T>(url: string): Promise<T> {
    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    });
  }

  async loadBinderTags() {
    const shortCode = this.createShortCode(this.collectionType);
    if (shortCode !== null) {
      const data: FilterTag[] = await this.fetchApi(
        this.baseURI + shortCode
      );
      return data;
    }
    return [];
  }
}

(window as any).CollectionFilters = CollectionFilters;
